import { saveAs } from "file-saver";
import FontFa from "../../../../components/fontFa/fontFa";
import { getDDMMYYYFormat } from "../../../../helper/dateTimeHelper";
import {
  AlignmentType,
  BorderStyle,
  Document,
  Header,
  HeightRule,
  ImageRun,
  Packer,
  PageNumber,
  PageOrientation,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  VerticalMergeType,
  WidthType,
  convertInchesToTwip,
} from "docx";
import { logoBase64 } from "../../../procedure/info-technology-process/repair-tools/base64";
import {
  C,
  DocXTableColumn,
  table,
  text,
} from "../../../procedure/company-office/request-vehicle/TemplateDocx/Template/common";
import { CreateNotification } from "../../../../components/notifier";
import { useMemo } from "react";

export const WordTemplateItems2 = (props: any) => {
  const { document } = props;

  const endUserList = useMemo(() => {
    if (!document?.fileAssignedTo) return [];

    const endUser = JSON.parse(document?.fileAssignedTo);

    const { Title, docCode, docPublishViewVersion, docEditionVersion, docPublicDepartment, lastModifiedDateTime } =
      document;

    return endUser.map((e: any) => ({
      name: e.displayName,
      department: e.department,
      Title: Title,
      docCode: docCode,
      docPublishViewVersion: docPublishViewVersion,
      docEditionVersion: docEditionVersion,
      docPublicDepartment: docPublicDepartment,
      lastModifiedDateTime: lastModifiedDateTime,
    }));
  }, [document]);

  const columnsList: DocXTableColumn<{
    Title: string;
    docCode: string;
    docPublishViewVersion: string;
    docEditionVersion: string;
    docPublicDepartment: string;
    lastModifiedDateTime: string;
    department: string;
    name: string;
  }>[] = [
    {
      label: "STT",
      renderText: (item, index) => text({ text: (index + 1).toString() }, { alignment: AlignmentType.CENTER }),
    },
    {
      label: "Tên tài liệu",
      renderText: (item) => text({ text: item.Title?.toString() }, { alignment: AlignmentType.LEFT }),
    },
    {
      label: "Mã số",
      renderText: (item) => text({ text: item.docCode?.toString() }, { alignment: AlignmentType.LEFT }),
    },
    {
      label: "Lần Ban hành/ sửa đổi",
      renderText: (item) =>
        text(`${item.docPublishViewVersion?.toString() || ""}/${item.docEditionVersion?.toString() || ""}`),
    },
    {
      label: "Số lượng(bộ)",
      renderText: () => text({ text: "01" }, { alignment: AlignmentType.RIGHT }),
    },
    {
      label: "Cơ quan/đơn vị nhận tài liệu",
      renderText: (item) => text({ text: item.department?.toString() }, { alignment: AlignmentType.LEFT }),
    },
    {
      label: "Ngày nhận",
      renderText: (item) => text(getDDMMYYYFormat(item.lastModifiedDateTime) || ""),
    },
    {
      label: "Người nhận (Xác nhận)",
      renderText: (item) => text({ text: "" }, { alignment: AlignmentType.LEFT }),
    },
  ];

  const docxTemplate = new Document({
    sections: [
      {
        properties: {
          page: {
            margin: {
              top: convertInchesToTwip(1),
              bottom: convertInchesToTwip(1),
              left: convertInchesToTwip(1),
              right: convertInchesToTwip(1),
            },
            size: {
              orientation: PageOrientation.LANDSCAPE,
            },
          },
        },
        headers: {
          default: new Header({
            children: [
              new Table({
                width: {
                  size: "100%",
                  type: WidthType.PERCENTAGE,
                },
                rows: [
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(30, [
                          new Paragraph({
                            children: [
                              new ImageRun({
                                data: logoBase64,
                                transformation: {
                                  width: 150,
                                  height: 40,
                                },
                              }),
                            ],
                            alignment: AlignmentType.CENTER,
                          }),
                        ]),
                        verticalAlign: VerticalAlign.CENTER,
                        rowSpan: 4,
                      }),

                      new TableCell({
                        ...C.col(40, [text({ size: 24, text: "Biểu mẫu", italics: true })]),
                        borders: { bottom: { style: BorderStyle.NIL } },
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                      new TableCell({
                        ...C.col(30, [text({ size: 24, text: "Mã số: V.QMS-F01" })]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                    height: {
                      value: 800,
                      rule: HeightRule.AUTO,
                    },
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(44, [
                          text(
                            { size: 28, text: "DANH SÁCH PHÂN PHỐI TÀI LIỆU", bold: true },
                            { alignment: AlignmentType.CENTER },
                          ),
                        ]),
                        rowSpan: 3,
                        borders: { top: { style: BorderStyle.NIL } },
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                        verticalMerge: VerticalMergeType.RESTART,
                        verticalAlign: VerticalAlign.TOP,
                      }),
                      new TableCell({
                        ...C.col(30, [text({ size: 24, text: "Ban hành: 01" })]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                    height: {
                      value: 500,
                      rule: HeightRule.AUTO,
                    },
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(30, [text({ size: 24, text: "Hiệu lực: 10/07/2022" })]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                  }),
                  new TableRow({
                    children: [
                      new TableCell({
                        ...C.col(33, [
                          new Paragraph({
                            children: [
                              new TextRun({
                                text: "Trang: ",
                                size: 24,
                              }),
                              new TextRun({
                                children: [PageNumber.CURRENT, "/", PageNumber.TOTAL_PAGES],
                                size: 24,
                              }),
                            ],
                          }),
                        ]),
                        margins: {
                          left: convertInchesToTwip(0.07),
                          right: convertInchesToTwip(0.07),
                        },
                      }),
                    ],
                  }),
                ],
              }),
              new Paragraph(""),
            ],
          }),
        },
        children: [
          table({
            columns: columnsList,
            data: endUserList,
          }),
        ],
      },
    ],
  });

  const saveAsDocx = async () => {
    Packer.toBlob(docxTemplate).then((blob) => {
      saveAs(blob, `V.QMS-F02- DANH SACH PHAN PHOI TAI LIEU (${document.Title}).docx`);
      CreateNotification({
        title: "Thông báo",
        body: "Xuất BM02 thành công!",
        icon: "/icons/success.png",
      });
    });
  };

  return (
    document && (
      <>
        <div onClick={saveAsDocx} style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}>
          <FontFa name="faFileWord" size="lg" color={"#0F4C81"} /> V.QMS-F02- DANH SACH PHAN PHOI TAI LIEU
        </div>
      </>
    )
  );
};
